// extracted by mini-css-extract-plugin
export default {"add-meeting__button":"styles_add-meeting__button__y9bi5"};